<template>
  <div class="internal-user-in-modal">
    <v-layout
      row
      align-center
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense font-weight-medium black--text">{{ transactionPartyType | optionName(transactionPartyOptions) }}</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div
          :id="`review-${transactionPartyType}-name`"
          class="font-weight-medium"
        >{{ transactionData.accountName }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Registration number</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div :id="`review-${transactionPartyType}-reg-num`">{{ transactionData.accountRegNumber }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Address</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div :id="`review-${transactionPartyType}-address`">{{ transactionData.accountAddress }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Country</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div :id="`review-${transactionPartyType}-country`">{{ getCountryName(transactionData.accountCountry) }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">IBAN</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div :id="`review-${transactionPartyType}-iban`">{{ transactionData[transactionPartyType] }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Bank name</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-bank-name">{{ transactionData.bankName }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Bank SWIFT</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-bank-swift">{{ transactionData.bankSwift }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Bank country</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-bank-country">{{ getCountryName(transactionData.bankCountry) }}</div>
      </v-flex>
    </v-layout>

    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Bank address</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-bank-address">{{ transactionData.bankAddress }}</div>
      </v-flex>
    </v-layout>

    <template v-if="isWithdrawalTransaction">
      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Bank sort code</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-bank-sort-code">{{ transactionData.bankSortCode }}</div>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Bank BIK</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-bank-bik">{{ transactionData.bankBik }}</div>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Bank VO code</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-bank-vo-code">{{ transactionData.bankVoCode }}</div>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Bank ABA routing number</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-bank-aba-number">{{ transactionData.bankAbaNumber }}</div>
        </v-flex>
      </v-layout>
    </template>

    <template v-if="transactionData.useCorrespondentBank">
      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Correspondent bank SWIFT</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-correspondent-bank-swift">{{ transactionData.correspondentBankSwift }}</div>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Correspondent bank name</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-correspondent-bank-name">{{ transactionData.correspondentBankName }}</div>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Correspondent bank BIK</v-subheader>
        </v-flex>
        <v-flex xs8>
          <div id="review-correspondent-bank-bik">{{ transactionData.correspondentBankBik }}</div>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
  // Models
  import Transaction, { TRANSACTIONS, TRANSACTION_PARTY_TYPES } from '@/models/Transaction'

  // Mixins
  import countries from '@/mixins/countries'

  export default {
    name: 'ExternalDataInModal',
    mixins: [countries],
    props: {
      transactionType: {
        required: true,
        type: String,
        validate: (value) => [TRANSACTIONS.WITHDRAWAL, TRANSACTIONS.TOPUP].includes(value)
      },
      transactionData: {
        required: true,
        type: Object
      }
    },
    computed: {
      isWithdrawalTransaction () {
        return this.transactionType === TRANSACTIONS.WITHDRAWAL
      },
      transactionPartyOptions () {
        return Transaction.partyOptions
      },
      transactionPartyType () {
        return this.isWithdrawalTransaction ? TRANSACTION_PARTY_TYPES.RECIPIENT : TRANSACTION_PARTY_TYPES.SENDER
      }
    }
  }
</script>

<style lang="scss">
  .internal-user-in-modal {
    .layout.row {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
</style>
